import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApplicationStateService } from './application-state.service';

@Injectable({
    providedIn: 'root'
})
export class RouteService {

    constructor(private applicationStateService: ApplicationStateService) {
    }

    /**
     * Get link to booklist.
     *
     * @returns {string}
     */
    getBookListLink(): string {
        let link: string = this.applicationStateService.bookConfig.listLink;
        if (this.applicationStateService.isOfflineModeEnabled) {
            link = this.applicationStateService.baseUrl + link;
        }

        return link;
    }

    /**
     * Get link to book.
     *
     * @returns {string}
     */
    getBookLink(): string {
        let link: string = this.applicationStateService.bookConfig.link;
        if (this.applicationStateService.isOfflineModeEnabled) {
            link = this.applicationStateService.baseUrl + link;
        }

        return link;
    }

    /**
     * Get link to mbook.
     *
     * @returns {string}
     */
    getmBookLink(page?: number): string {
        //let link = `${environment.mBookUrl}mbooks/${this.applicationStateService.bookConfig.quickLinkPrefix}`;

        // if (page && page > 0) {
        //     // eslint-disable-next-line max-len
        //     link = `${link}?page=${page}&bookSlug=${this.applicationStateService.bookConfig.slug}&bookId=${this.applicationStateService.bookId}`;
        // } else {
        //   link += `?bookSlug=${this.applicationStateService.bookConfig.slug}&bookId=${this.applicationStateService.bookId}`;
        // }

        return `${environment.mBookUrl}mbooks/${this.applicationStateService.bookConfig.quickLinkPrefix}`;
    }

    /**
     * Get link to schoolbag.
     *
     * @returns {string}
     */
    getSchoolbagLink(): string {
        return this.getAbsoluteRoute(environment.internalUrls.schoolbag, {});
    }

    /**
     * Get the relative url to a named route.
     *
     * @param {string} routeName
     * @param {Array<any> | object} params
     * @returns {string}
     */
    getRelativeRoute(routeName: string, params: Array<any> | object): string {
        return this.getRoute(routeName, params, false);
    }

    /**
     * Get the absolute url to a named route.
     *
     * @param {string} routeName
     * @param {Array<any> | object} params
     * @returns {string}
     */
    getAbsoluteRoute(routeName: string, params: Array<any> | object): string {
        // Don't use "absolute urls" from route helper, because these do not link to the current domain
        return this.applicationStateService.baseUrl + this.getRoute(routeName, params, false);
    }

    /**
     * Get url to a named route.
     *
     * @param {string} routeName
     * @param {Array<any> | object} params
     * @param {boolean} absolute
     * @returns {string}
     */
    private getRoute(routeName: string, params: Array<any> | object, absolute: boolean): string {
        if (this.applicationStateService.isOfflineModeEnabled) {

            if (routeName === 'faq') {
                return `/${routeName}`;
            }

            if (routeName === 'contact') {
                return '/kontakt';
            }

            return routeName;
        }

        const route: string = window.window['route'](routeName, params, absolute).toString();

        if (!route && routeName !== 'front') {
            throw new Error(`No route found for '${routeName}'.`);
        }

        return route;
    }
}
